import NepaliDate from 'nepali-datetime';
import { NepaliMonthOptions } from '../constants/Options';

export const NowNepDateGet = (): string => {
    const now = new NepaliDate();
    const NOW_FORMAT = now.format('YYYY/MM/DD')
    return NOW_FORMAT.toString();
}

export const formatMoney = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'NPR', // Use the currency you need
        minimumFractionDigits: 2, // Ensure two decimal places
        maximumFractionDigits: 2, // Ensure two decimal places
    }).format(amount);
};

export const formatMoney_2 = (number:number) => {
    const { FormatMoney } = require('format-money-js');
    const fm = new FormatMoney({
        decimals: 2
    });
    const convertedData = fm.from(number?number:0);
    return convertedData;
}

export const CountNepaliDays = (date1BS: string, date2BS: string): string => {
    const date1AD = new NepaliDate(date1BS);
    const date2AD = new NepaliDate(date2BS);
    const differenceInTime = date1AD.getTime() - date2AD.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return `${differenceInDays} days remaining`;
}

export const NumberToNepaliNum = (number:number|string) => {
    const nepaliNumber = require('nepali-number');
    const convert_num = nepaliNumber.englishToNepaliNumber(number, "ne");
    return convert_num;
};


export const nepaliMonthName = (id: number): string =>{
    var month_name = ""
    if (id < 0 || id > 12){
        month_name = "unknown"
    }else {
        const month_list = NepaliMonthOptions;
        const get_month = month_list.filter((item)=>parseInt(item.value) === id);
        month_name = get_month[0].label
    }
    return month_name
}
// Convert to AD (Gregorian) dates


// Calculate the difference in days
